// Frontend-only config for the dynamic lead importer: the canonical fields the UI
// maps to, and per-format presets that pre-fill the column selection. The backend
// is generic — it just processes the canonical rows the mapper produces, so all of
// this lives here, not in Ruby.

// target is informational (groups the mapping UI into Lead / Company sections).
export const FIELDS = [
  { key: "full_name", label: "Full name", target: "lead" },
  { key: "first_name", label: "First name", target: "lead" },
  { key: "last_name", label: "Last name", target: "lead" },
  { key: "title", label: "Title", target: "lead" },
  { key: "email", label: "Email", target: "lead" },
  { key: "linkedin", label: "LinkedIn URL", target: "lead" },
  { key: "company_name", label: "Company name", target: "company", required: true },
  { key: "company_website", label: "Company website", target: "company" },
  { key: "company_linkedin", label: "Company LinkedIn URL", target: "company" },
  { key: "company_location", label: "Company location", target: "company" },
  { key: "company_city", label: "Company city", target: "company" },
  { key: "company_state", label: "Company state", target: "company" },
  { key: "company_country", label: "Company country", target: "company" },
  { key: "company_size", label: "Company size", target: "company" },
]

// A lead is mandatory, so every row needs a person name AND a company name.
// company_name is the single required column; the name requirement is a group
// (a full name column, OR first + last).
export const REQUIRED_KEYS = ["company_name"]
export const NAME_GROUPS = [["full_name"], ["first_name", "last_name"]]

export const PRESETS = [
  { key: "generic", name: "Generic / custom", columnMap: {} },
  {
    key: "apollo",
    name: "Apollo (Contacts export)",
    columnMap: {
      first_name: "First Name", last_name: "Last Name", title: "Title", email: "Email",
      linkedin: "Person Linkedin Url", company_name: "Company Name", company_website: "Website",
      company_linkedin: "Company Linkedin Url", company_city: "Company City",
      company_state: "Company State", company_country: "Company Country", company_size: "# Employees",
    },
  },
  {
    key: "clay",
    name: "Clay (B2B export)",
    // Clay's `title` is the business name -> feed both the lead name and the company name.
    columnMap: {
      full_name: "title", company_name: "title", company_location: "address",
      company_website: "website", email: "Contact Email",
    },
  },
]
